<template>
  <div>
    <div class="footer">
      <div class="container">
        <div class="box-left">
          <div class="content">
            <h1>产品中心</h1>
            <p @click="go('/crm')">CRM&SCRM</p>
            <p @click="go('/marketingPlatform')">智能营销平台</p>
            <p @click="go('/weChat')">企业微信应用</p>
            <p @click="go('/datePlatform')">客户数据平台</p>
          </div>
          <div class="content">
            <h1>解决方案</h1>
            <p class="special" @click="go('/solution-market')">零售行业解决方案</p>
            <p class="special" @click="go('/solution-conversion')">销售线索解决方案</p>
          </div>
          <div class="content">
            <h1>合作案例</h1>
            <p class="width-35" @click="go(`/caseCar?type=0&time=${new Date().getTime()}`)">服装</p>
            <p class="width-50" @click="go(`/caseCar?type=1&time=${new Date().getTime()}`)">化妆品</p>
            <p class="width-50" @click="go(`/caseCar?type=2&time=${new Date().getTime()}`)">消费品</p>
            <p class="width-35" @click="go(`/caseCar?type=3&time=${new Date().getTime()}`)">汽车</p>
          </div>
          <div class="content">
            <h1>关于我们</h1>
            <p class="width-66" @click="go('/about')">关于我们</p>
            <p class="width-66" @click="go('/recruit')">英檬招聘</p>
          </div>
        </div>
        <div class="box-right">
          <div class="content">
            <img src="@/assets/images/logo-white.png">
            <div>
              <p><span>电</span><span>话</span></p>：021-62660613
            </div>
            <div>
              <p><span>业</span><span>务</span><span>咨</span><span>询</span></p>：marketing@indation.com
            </div>
            <div>
              <p><span>技</span><span>术</span><span>支</span><span>持</span></p>：support@indation.com
            </div>
            <div>
              <p><span>简</span><span>历</span><span>投</span><span>递</span></p>：hr@indation.com
            </div>
            <div>
              <p><span>公</span><span>司</span><span>地</span><span>址</span></p>：上海市普陀区智慧产业科技园2号楼101
            </div>
            <div>
              <p><span>邮</span><span>编</span></p>：200063
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="bg">
        <div class="bg-left"></div>
        <div class="bg-right"></div>
        <div class="clear"></div>
      </div>
      <div class="remark">
        <div class="box">
          <!-- <img src="@/assets/images/logo-white.png"> -->
          <p>版权所有  ©上海英檬科技有限公司 沪ICP备18018622号-1 </p>
        </div>
      </div>
    </div>
    <!-- <div class="remark">
      <div class="box">
        <img src="@/assets/images/logo-white.png">
        <p>版权所有  ©上海英檬科技有限公司 沪ICP备18018622号-1 </p>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "footer-bar",
  methods: {
    // 导航跳转
    go(index) {
      this.$router.push(index);
    },
  }
}
</script>
<style lang="scss" scoped>
.footer {
  max-width: 1920px;
  width: 100%;
  height: 470px;
  background: #252525;
  margin: 0 auto;
  position: relative;
  bottom: 0;
  .container {
    width: $min-screen-width;
    margin: 0 auto;
    position: relative;
    z-index: 15;
    .box-left {
      background: #252525;
      width: 710px;
      height: 390px;
      padding-top: 68px;
      box-sizing: border-box;
      float: left;
      .content {
        float: left;
        padding-right: 58px;
        .special {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          // line-height: 20px;
          color: #FFFFFF;
        }
        h1 {
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FFFFFF;
          padding-bottom: 35px;
        }
        p {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          // padding-bottom: 25px;
          padding-bottom: 10px;
          margin-bottom: 14px;
          border-bottom: 1px solid transparent;
          cursor: pointer;
          &:hover {
            border-bottom: 1px solid #fff;
          }
        }
      }
    }
    .box-right {
      width: 490px;
      float: left;
      height: 390px;
      // background: #484848;
      position: relative;
      .content {
        position: absolute;
        top: 68px;
        left: 46px;
        width: 100%;
        img {
          margin-bottom: 40px;
        }
        div {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          line-height: 25px;
          color: #FFFFFF;
          display: flex;
          > p {
            display: flex;
            width: 60px;
            justify-content: space-between;
          }
        }
      }
    }
  }
}

.bg {
  width: 100%;
  position: absolute;
  z-index: 10;
  bottom: 0;
  top: 0;
  height: calc(100% - 80px);
  &-left {
    float: left;
    height: 100%;
    width: 50%;
    background: #252525;
  }
  &-right {
    float: right;
    width: 50%;
    height: 100%;
    background: #252525;
  }
}

.remark {
  // margin: 0 auto;
  // max-width: 1920px;
  // min-width: $min-screen-width;
  height: 80px;
  background: #3B3B3B;
  .box {
    width: $min-screen-width;
    margin: 0 auto;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    img {
      margin-right: 453px;
    }
    p {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      line-height: 27px;
      color: #FFFFFF;
    }
  }
}

.clear {
  clear: both;
}

.width-168 {
  width: 168px;
}
.width-50 {
  width: 42px;
}
.width-66 {
  width: 56px;
}
.width-35 {
  width: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/footer-bar.vue